import React, { useCallback } from "react";
import { toast } from "react-hot-toast";
import AlertIcon from "./images/icons/alert.svg?react";
import CircleCheckIcon from "./images/icons/circle-check.svg?react";
import CircleXIcon from "./images/icons/circle-x.svg?react";
import InfoIcon from "./images/icons/info.svg?react";
import CloseIcon from "@/common/images/icons/x.svg?react";
import { Button } from "@/components/buttons/Button";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";
import "./Notification.scss";

export type FlagVariant = "default" | "success" | "error" | "warning" | "info";

type TBtn = {
  title: string;
  onClick: () => void;
}

export interface INotificationProps {
  id?: string;
  title: string;
  description?: string;
  variant: FlagVariant;
  actionButton?: TBtn;
  secondaryButton?: TBtn;
}

const variantIconMapping: Record<FlagVariant, React.ReactElement | null> = {
  default: null,
  success: <CircleCheckIcon data-testid="icon-success" />,
  error: <CircleXIcon data-testid="icon-error" />,
  warning: <AlertIcon data-testid="icon-warning" />,
  info: <InfoIcon data-testid="icon-info" />,
};

export const Notification: React.FC<INotificationProps> = ({
  title,
  id,
  description,
  variant,
  actionButton,
  secondaryButton
}) => {
  const isMobile = useDeviceType() === deviceTypeEnum.PHONE;
  const Icon = variantIconMapping[variant];

  const onButtonClick = useCallback((button?: TBtn) => {
    toast.dismiss(id);
    button?.onClick();
  }, [id]);

  return (
    <div className={`Notification Notification_${variant} ${description ? "Notification_isComplex" : ""}`}>
      <div className="Notification-Default">
        {Icon && <span className="Notification-Icon">{Icon}</span>}
        <span className="Notification-Title">{title}</span>
        <button className="Notification-Close" onClick={() => toast.remove(id)} aria-label="Close notification"><CloseIcon className="CloseIcon" /></button>
      </div>
      {description && <p className="Notification-Description">{description}</p>}
      <div className="Notification-Footer">
        {secondaryButton && <button className="Notification-SecBtn" onClick={() => onButtonClick(secondaryButton)}>{secondaryButton.title}</button>}
        {actionButton && <Button variant="secondary" size={isMobile ? "m" : "l"} className="Notification-PrimeBtn" onClick={() => onButtonClick(actionButton)} aria-label={actionButton.title}>{actionButton.title}</Button>}
      </div>
    </div>
  );
};

